import Cookies from 'js-cookie'

// tab 变色切换

export function tabSwitch(bus,index,doms){
	if(bus.$refs[doms]){
		bus.$refs[doms].forEach((ele, Mindex) => {
			index === Mindex ? (bus.$refs[doms][Mindex].style.color = '#F9BE04')
				: (bus.$refs[doms] [Mindex].style.color = '#D3D3D2')
			index === Mindex ? (bus.$refs[doms][Mindex].style.border = '1px solid #F9BE04')
				: (bus.$refs[doms][Mindex].style.border = '1px solid #D3D3D2')
		})
	}
}
export function getCookie(e='access_token') {
    return Cookies.get(e)
}

export function setToken(k,y,num=7) {
    return Cookies.set(k, y,{ expires: num,domain:'hd199.com'})
}
export function setCookie(k,y,num=7) {
    return Cookies.set(k, y,{ expires: num,domain:'hd199.com'})
}
export function clearCookie(e='access_token') {
    return Cookies.remove(e)
}
export function setLoc(key, data) {
    return localStorage.setItem(key, data)
}
export function getLoc(key) {
    return localStorage.getItem(key)
}
export function removeLoc(e='access_token') {
    return localStorage.removeItem(e)
}
export function clearCookieAll() {
	var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
	if (keys) {
		for (var i = keys.length; i--;) {
			document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的
			document.cookie = keys[i] + '=0;path=/;domain=hd199.com;expires=' + new Date(0).toUTCString();//清除一级域名下的
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/js/common.js